import { IOptionItem } from '@wyz/types';
import { Col, Label, Row } from '@wyz/ui';
import { SelectField, SwitchField } from '~/common/components';
import { Trans } from '~/common/context';
import {
  IAdvancedExtraBonusDraft,
  IDistributionPricingPolicySeason,
  IVehicleTypeColumn,
} from '~/purchase/types';
/* eslint-disable-next-line @wyz/module/no-relative-import -- the sibling is imported directly: going
   through the ~/purchase/components barrel would make this module depend on itself. */
import { AdvancedBonusMatrix } from './advanced-bonus-matrix';

type Props = {
  draft: IAdvancedExtraBonusDraft;
  seasons: IDistributionPricingPolicySeason[];
  vehicleTypes: IVehicleTypeColumn[];
  bonusTypeOptions: IOptionItem[];
};

/** The bonus of the advanced screen: its type, the axes it targets, and its amounts. */
export function AdvancedBonusBlock({
  draft,
  seasons,
  vehicleTypes,
  bonusTypeOptions,
}: Props) {
  return (
    <div className='advanced-extra-bonus__bonus'>
      <Row className='align-items-center'>
        <Col md={6}>
          <SelectField
            name='bonusType'
            formGroupClassName='d-flex align-items-center space-x-2 w-100'
            size='sm'
            isSearchable={false}
            options={bonusTypeOptions}
            label={
              <Trans i18nKey='app.distribution.pricing_policy.detail.advanced.bonus_configuration' />
            }
            required
          />
        </Col>
        <Col
          md={6}
          className='d-flex space-x-2 align-content-center justify-content-end'
        >
          <div>
            {/* Empty label needed to align the switch field with the other fields */}
            <Label></Label>
            <SwitchField
              name='byVehicleType'
              variant='DOUBLE'
              leftLabel=''
              rightLabel={
                <Trans i18nKey='app.distribution.pricing_policy.detail.advanced.by_vehicle_type' />
              }
              size='md'
            />
          </div>
          <div>
            {/* Empty label needed to align the switch field with the other fields */}
            <Label></Label>
            <SwitchField
              name='byDiameter'
              variant='DOUBLE'
              leftLabel=''
              rightLabel={
                <Trans i18nKey='app.distribution.pricing_policy.detail.advanced.by_diameter' />
              }
              size='md'
            />
          </div>
        </Col>
      </Row>

      <AdvancedBonusMatrix
        draft={draft}
        seasons={seasons}
        vehicleTypes={vehicleTypes}
      />
    </div>
  );
}
